// Generated by scripts/sync-catalog-sitemap.mjs — do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const providersSlugMap = {
    "1x2gaming": "1X2gaming",
    "3oaks": "3oaks",
    "4theplayer": "4ThePlayer",
    "adlunam": "AdLunam",
    "avatarux": "AvatarUX",
    "aviatrix": "Aviatrix",
    "bang-bang-games": "Bang Bang Games",
    "bgaming": "BGaming",
    "bigpot-gaming": "Bigpot Gaming",
    "blue-guru": "Blue Guru",
    "blueprint-gaming": "Blueprint Gaming",
    "boominggames": "BoomingGames",
    "bulletproof-games": "Bulletproof Games",
    "electric-elephant": "Electric Elephant",
    "evoplay": "Evoplay",
    "expanse-studios": "Expanse Studios",
    "fantasma": "Fantasma",
    "fbastards": "Fbastards",
    "four-leaf-gaming": "Four Leaf Gaming",
    "galaxsys": "Galaxsys",
    "gametech": "GameTech",
    "gamevy": "Gamevy",
    "gamomat-games": "Gamomat Games",
    "habanero": "Habanero",
    "hacksaw-gaming": "Hacksaw Gaming",
    "hot-rise-games": "Hot Rise Games",
    "indigomagic": "IndigoMagic",
    "irondog": "IronDog",
    "jili-games": "Jili Games",
    "manna-play": "Manna Play",
    "million-games": "Million Games",
    "netent": "NetEnt",
    "northern-lights-gaming": "Northern Lights Gaming",
    "peter-and-sons": "Peter & Sons",
    "pgsoft": "PGSoft",
    "pinoy-bet-games": "Pinoy Bet Games",
    "play-n-go": "Play n GO",
    "playzia": "Playzia",
    "pragmatic-play": "Pragmatic Play",
    "pragmatic-play-live": "Pragmatic Play Live",
    "print-studios": "Print Studios",
    "prospectgaming": "ProspectGaming",
    "push-gaming": "Push Gaming",
    "quickspin": "Quickspin",
    "ready-play-gaming": "Ready Play Gaming",
    "reelplay": "ReelPlay",
    "reflex-gaming": "Reflex Gaming",
    "relax-gaming": "Relax Gaming",
    "rogue-gaming": "Rogue Gaming",
    "slingo": "Slingo",
    "slotmill": "Slotmill",
    "solvited": "Solvited",
    "storm-gaming": "Storm Gaming",
    "tomhorn": "TomHorn",
    "topspin": "Topspin",
    "trigger": "Trigger",
    "wazdan": "Wazdan",
    "winfast": "Winfast",
};
